import React from "react";
import { withTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router";

import { TabProps } from "@models/shared/shared.model";
import organisationSlice from "@slices/organisation.slice";
const TabsComponent: React.FC<TabProps> = ({ labels }) => {
  const location = useLocation();
  const dispatch = useDispatch();

  const path = location.pathname.split("/");
  const navigate = useNavigate();
  const onNavigate = (route: string) => {
    navigate(route);
  };

  const handleTabChange = (route: string) => {
    onNavigate(route);
    dispatch(organisationSlice.actions.changeLocationId({ id: "0" }));
    dispatch(organisationSlice.actions.changeResourceId({ id: "0" }));
  };
  return (
    <div className="container" data-testid="tabs-test">
      <ul
        className="nav nav-pills"
        id="pills-tab"
        role="tablist"
        data-testid="tabs-list"
      >
        {labels.map((obj, index) => {
          return (
            <li className={"nav-item"} role="presentation" key={index}>
              <button
                className={`nav-link ${
                  path.slice(-1).includes(obj.name.toLowerCase()) && "active"
                }`}
                type="button"
                role="tab"
                onClick={() => handleTabChange(obj.route)}
                data-testid="tab-item"
              >
                {obj.label}
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

const Tabs = withTranslation()(TabsComponent);

export default Tabs;
